export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/menu_design.e683c8a.svg";